import React from "react";
import MDialog from "./MDialog";

export interface MVideoPlayerProps {
  videoUrl: string;
  open: boolean;
  onClose: () => void;
  title?: string;
  autoplay?: boolean;
}

const getYouTubeEmbedUrl = (url: string, autoplay: boolean): string | null => {
  const match = url.match(
    /(?:youtu.be\/|youtube.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/
  );
  if (!match) return null;

  const base = `https://www.youtube.com/embed/${match[1]}`;

  if (!autoplay) return base;

  // YouTube will block autoplay unless muted
  return `${base}?autoplay=1&mute=1`;
};

const MVideoPlayer: React.FC<MVideoPlayerProps> = ({
  videoUrl,
  open,
  onClose,
  title = "Video Player",
  autoplay = false,
}) => {
  const youtubeEmbed = getYouTubeEmbedUrl(videoUrl, autoplay);

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={title}
      primaryCtaText="Close"
      onPrimaryCta={onClose}
      showPrimaryCta={false}
      titleVariant="sm"
    >
      <div
        style={{
          width: "100%",
          aspectRatio: "16/9",
          position: "relative",
          margin: 0,
          padding: 0,
        }}
      >
        {youtubeEmbed ? (
          <iframe
            src={youtubeEmbed}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        ) : (
          <video
            src={videoUrl}
            controls
            autoPlay={autoplay}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </div>
    </MDialog>
  );
};

export default MVideoPlayer;
